module.exports = __webpack_public_path__ + "common/sidebar/icon-convenience-store-db3b0b0f5cbfc0119805ac5faa124d64.svg";